import { get, post } from '@/common/request.js'

// 登录
export function login(data) {
	return get('account/wxLogin', data)
}